import {useForm} from '@tanstack/react-form';
import {useMaterialVariationMachinePreselectQuery} from './useMaterialVariationMachinePreselectQuery';
import {useMaterialVariationMachinePreselectUpdateMutation} from './useMaterialVariationMachinePreselectUpdateMutation';
import {useProductionMachineList} from '../../production/machines/useProductionMachineListQuery';
import {EvInputField} from '../../form/EvInputField';
import {EvButton} from '../../form/EvButton';
import {clsx} from 'clsx';
import {EvReactModal} from '../../modal/EvReactModal';

interface Props {
  variationId: number;
  formSuccess: () => void;
}

export function MaterialVariationMachinePreselectForm(props: Props) {
  const preselect = useMaterialVariationMachinePreselectQuery(props.variationId);
  const machineList = useProductionMachineList({});
  const updateMutation = useMaterialVariationMachinePreselectUpdateMutation(props.variationId);

  const form = useForm({
    defaultValues: {
      machines: machineList.objects.map(m => ({
        id: m.id,
        name: m.name,
        selected: !!preselect.machines.find(p => m.id === p.id),
      })),
    },
    onSubmit: ({formApi}) => {
      updateMutation.mutate(
        {
          machineIds: formApi.state.values.machines
            .filter(m => m.selected)
            .map(m => m.id),
        },
        () => props.formSuccess(),
      );
    },
  });

  return <EvReactModal contentLabel={
    `Vorausgewählte Maschinen für Variation ${
      preselect.variation.variationId
    } ${
      preselect.article.name
    } bearbeiten`
  }
                       showModal={true}
                       modalClosed={() => props.formSuccess()}>
    <form onSubmit={async e => {
      e.preventDefault();
      await form.handleSubmit(e);
    }}>
      <div className="modal-body min-w-vw-30">
        <div className="grid grid-cols-10-80-10 h-dvh-70">
          <div className="grid col-span-3 grid-cols-subgrid
                          bg-storz-whitetable-background
                          border border-solid border-storz-whitetable-border">
            <div className="p-2 text-right">Nr.</div>
            <div className="p-2">Name</div>
            <div/>
          </div>
          <div className="grid col-span-3 grid-cols-subgrid
                          select-none
                          scrollbar-thin scroll-smooth
                          overflow-x-clip
                          overflow-y-hidden hover:overflow-y-auto focus:overflow-y-auto active:overflow-y-auto">
            <form.Field name="machines" mode="array">
              {field =>
                field.state.value.map((f, i) =>
                  <form.Field key={i} name={`machines[${i}].selected`}>
                    {(subField) =>
                      <div className={clsx(
                        'border',
                        'border-solid',
                        'border-storz-whitetable-border',
                        'border-b-0',
                        'last:border-b',
                        'grid',
                        'col-span-3',
                        'grid-cols-subgrid',
                        {
                          'bg-storz-green-select': !!subField.state.value,
                          'bg-white': !subField.state.value,
                        })}>
                        <label className="!mb-0 p-2 cursor-pointer text-right" htmlFor={subField.name}>
                          {f.id}
                        </label>
                        <label className="!mb-0 p-2 cursor-pointer" htmlFor={subField.name}>
                          {f.name}
                        </label>
                        <label className="!mb-0 p-2 cursor-pointer" htmlFor={subField.name}>
                          <EvInputField type="toggle" field={subField}/>
                        </label>
                      </div>
                    }
                  </form.Field>,
                )
              }
            </form.Field>
          </div>
        </div>
      </div>

      <div className="modal-footer">
        <EvButton className="w-full"
                  variant="success"
                  size="sm"
                  type="submit"
                  disabled={updateMutation.isPending}>
          Speichern
        </EvButton>
      </div>
    </form>
  </EvReactModal>;
}
